export default "__VITE_ASSET__SGvpgxtB__"